import { DropdownItem, DropdownSelectionEvent } from "@mcleod/components";
import { AutogenLayoutSalesPipelineReport } from "./autogen/AutogenLayoutSalesPipelineReport";

// Group By options
const groupBySalesperson = new DropdownItem("E", "Salesperson");
const sortBySalesperson = new DropdownItem("N", "Salesperson");
const salesStatus = new DropdownItem("S", "Sales Status");
const expectedClose = new DropdownItem("E", "Expected Close Date");
const customer = new DropdownItem("C", "Customer");
const potential = new DropdownItem("P", "Potential");

export class SalesPipelineReport extends AutogenLayoutSalesPipelineReport {

    onLoad(): void {
        this.textboxProspectsOpportunities.selectedItem = this.textboxProspectsOpportunities.items[0];
        this.textboxGroupBy.selectedItem = this.textboxGroupBy.items[0];
        this.textboxSortBy.selectedItem = this.textboxSortBy.items[0];
        this.textboxSecondarySortBy.selectedItem = this.textboxSecondarySortBy.items[0];
        this.textboxCustomerProspect.selectedItem = this.textboxCustomerProspect.items[0];
        // Set initial dropdown values based on default Group By selection
        this.updateSortByOptions(groupBySalesperson.value);
        this.updateSecondarySortByOptions(groupBySalesperson.value, salesStatus.value);
    }

    /** Event handler for when Group By dropdown selection changes */
    textboxGroupByAfterDropdownSelection(event: DropdownSelectionEvent): void {
        const selectedGroupBy = event.selection?.value;
        if (selectedGroupBy) {
            this.updateSortByOptions(selectedGroupBy);
            
            // Reset Sort By to first option
            const firstSortByOption = this.textboxSortBy.items[0] as DropdownItem;
            this.textboxSortBy.selectedItem = firstSortByOption;
            
            // Update Secondary Sort By based on new Group By and Sort By
            this.updateSecondarySortByOptions(selectedGroupBy, firstSortByOption.value);
            
            // Reset Secondary Sort By to first option
            if (this.textboxSecondarySortBy.items.length > 0) {
                this.textboxSecondarySortBy.selectedItem = this.textboxSecondarySortBy.items[0] as DropdownItem;
            }
        }
    }

    /** Event handler for when Sort By dropdown selection changes */
    textboxSortByAfterDropdownSelection(event: DropdownSelectionEvent): void {
        const selectedGroupBy = this.textboxGroupBy.selectedItem?.value;
        const selectedSortBy = event.selection?.value;
        
        if (selectedGroupBy && selectedSortBy) {
            this.updateSecondarySortByOptions(selectedGroupBy, selectedSortBy);
            
            // Reset Secondary Sort By to first option
            if (this.textboxSecondarySortBy.items.length > 0) {
                this.textboxSecondarySortBy.selectedItem = this.textboxSecondarySortBy.items[0] as DropdownItem;
            }
        }
    }

    /** Update Sort By dropdown based on Group By selection */
    private updateSortByOptions(groupBy: string): void {
        const sortByOptions: DropdownItem[] = [];
        
        if (groupBy === "E") { // Salesperson
            sortByOptions.push(salesStatus);
            sortByOptions.push(expectedClose);
        } else if (groupBy === "S") { // Sales Status
            sortByOptions.push(customer);
            sortByOptions.push(expectedClose);
            sortByOptions.push(potential);
        }
        
        this.textboxSortBy.items = sortByOptions;
    }

    /** Update Secondary Sort By dropdown based on Group By and Sort By selections */
    private updateSecondarySortByOptions(groupBy: string, sortBy: string): void {
        const secondarySortByOptions: DropdownItem[] = [];
        
        if (groupBy === "E") { // Group By Salesperson
            if (sortBy === "S") { // Sort By Sales Status
                secondarySortByOptions.push(potential);
                secondarySortByOptions.push(expectedClose);
            } else if (sortBy === "E") { // Sort By Expected Close Date
                secondarySortByOptions.push(salesStatus);
                secondarySortByOptions.push(potential);
            }
        } else if (groupBy === "S") { // Group By Sales Status
            if (sortBy === "P") { // Sort By Potential
                secondarySortByOptions.push(customer);
                secondarySortByOptions.push(sortBySalesperson);
                secondarySortByOptions.push(expectedClose);
            } else if (sortBy === "E") { // Sort By Expected Close Date
                secondarySortByOptions.push(customer);
                secondarySortByOptions.push(sortBySalesperson);
                secondarySortByOptions.push(potential);
            } else if (sortBy === "C") { // Sort By Customer
                secondarySortByOptions.push(sortBySalesperson);
                secondarySortByOptions.push(potential);
            }
        }
        
        this.textboxSecondarySortBy.items = secondarySortByOptions;
    }

     /**
     * Update the customer lookup model based on the selected customer/prospect type
     */
    textboxCustomerProspectOnChange(): void {
        const typeValue = this.textboxCustomerProspect.selectedItem?.value;

        // Get the textbox component from the excludable textbox
        const customerTextbox = this.excludabletextboxCustomerId.textbox;

        if (!customerTextbox) {
            return;
        }

        customerTextbox.clear();
        // Update lookup model based on selection
        // A = Both (PROSP_CUST), B = Prospects Only (PROSPECT), C = Customers Only (CUST_ALL)
        switch (typeValue) {
            default:
            case "B": // Both
                customerTextbox.caption = "Customer(s) / Prospect(s)";
                break;
            case "P": // Prospects Only
                customerTextbox.caption = "Prospect(s)";
                break;
            case "C": // Customers Only
                customerTextbox.caption = "Customer(s)";
                break;
        }
    }

    textboxCustomersBeforeLookupModelSearch(event) {
        const customersOrProspects = this.textboxCustomerProspect.selectedItem?.value;
        switch (customersOrProspects) {
            default:
            case "B": // Both
                // No filtering
                break;
            case "P": // Prospects Only
                event.filter.type_of = "P"; // Filter to prospects only
                break;
            case "C": // Customers Only
                event.filter.type_of = "C"; // Filter to customers only
        }
    }

}
